import { render, staticRenderFns } from "./TK.vue?vue&type=template&id=eb5a2d0c&"
import script from "./TK.vue?vue&type=script&lang=js&"
export * from "./TK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports